import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-163" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-165" data-mp="3fyvxs9ef7bak">
          What Teachers Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-166" data-mp="36ypo6yluevgo">
          <span aria-hidden="true" data-id="element-167" data-mp="36wwgrh3eo77m">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +2,000 Teachers
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-168" data-mp="31yl7b7h0vypx">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-169" data-mp="2x2mm1sqzqwtq">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-170" data-mp="v9oppmy09m41">
                <span aria-hidden="true" data-id="element-171" data-mp="qav93lnf9ezn">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-172" data-mp="h4wui1ce4aho">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-173" data-mp="78abli3mjtia">
                <p className="text-xs font-bold text-ink" data-id="element-174" data-mp="79bo7r0ago24">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-175" data-mp="c7wotrjgd9r3">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-176" data-mp="zyiwvitgiu13">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}